import { Button, Avatar, Space, Typography } from "antd"
import { EyeOutlined, CloseCircleOutlined, UserOutlined } from "@ant-design/icons"
import useViewModeStore from "../../../store/viewMode/useViewModeStore"

const { Text } = Typography

export default function ViewModeBanner() {
  const { isViewMode, viewingAs, exitViewMode } = useViewModeStore()

  if (!isViewMode || !viewingAs) return null

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        height: 40,
        background: "linear-gradient(90deg, #cf1322 0%, #ff4d4f 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 20px",
        boxShadow: "0 2px 8px rgba(207,19,34,0.45)",
      }}>
      <Space>
        <EyeOutlined style={{ color: "#fff", fontSize: 15 }} />
        <Avatar
          src={viewingAs.photoURL}
          icon={<UserOutlined />}
          size={22}
          style={{ backgroundColor: "rgba(255,255,255,0.25)" }}
        />
        <Text style={{ color: "#fff", fontWeight: 600, fontSize: 13 }}>
          Viewing as: {viewingAs.displayName || viewingAs.email}
        </Text>
        <Text style={{ color: "rgba(255,255,255,0.7)", fontSize: 12 }}>· {viewingAs.email}</Text>
      </Space>

      <Button
        type="text"
        size="small"
        icon={<CloseCircleOutlined />}
        onClick={exitViewMode}
        style={{ color: "#fff", fontWeight: 600 }}>
        Exit View Mode
      </Button>
    </div>
  )
}
